import React from 'react'

import classes from './ActionBar.scss'

import ActionGroup from './ActionGroup/ActionGroup'

const actionBar = ({
  exporting,
  importing,
  downloading,
  filtering,
  leftContent,
  importDisabled,
  exportDisabled,
  show
}) => {
  return (
    <div className={classes.ActionBar}>
      <div className={classes.Left}>{leftContent || null}</div>
      <div className={classes.Right}>
        <ActionGroup
          show={show}
          exportButtonClicked={exporting}
          importButtonClicked={importing}
          downloadButtonClicked={downloading}
          filterButtonClicked={filtering}
          importDisabled={importDisabled}
          exportDisabled={exportDisabled}
        />
      </div>
    </div>
  )
}

export default actionBar
